import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, query, orderBy, onSnapshot, getDoc, doc, where, getAggregateFromServer, sum, } from 'firebase/firestore'
import moment from 'moment';
import Select from 'react-select'
import { useReactToPrint } from 'react-to-print';


export default function Productwise() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    });

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setfromdate(formattedDate);
        settodate(formattedDate);
    }, []);

    const printRef = useRef();
    const [reportData, setreportData] = useState([]);
    const [fromdate, setfromdate] = useState("");
    const [todate, settodate] = useState("");
    const [totalamount, settotalamount] = useState("");

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })



   const getReport = () => {
    settotalamount(0);
    setreportData([]);

    const q1 = query(
        collection(db, 'productwisesale'),
        where('orderdate', '>=', fromdate),
        where('orderdate', '<=', todate)
    );

    onSnapshot(q1, (querySnapshot1) => {
        const productMap = new Map();
        let total_amount = 0;

        querySnapshot1.forEach((doc1) => {
            const data = doc1.data();

            // Normalize product name (trim spaces + make case consistent)
            const key = data.itemname.trim().toLowerCase();

            const rate = parseFloat(data.rate) || 0;
            const qty = parseFloat(data.quantity) || 0;
            const total = rate * qty;

            if (!productMap.has(key)) {
                productMap.set(key, {
                    itemname: data.itemname.trim(), // store original name nicely
                    rate,
                    quantity: qty,
                    total
                });
            } else {
                const existing = productMap.get(key);
                existing.quantity += qty;
                existing.total += total;
            }

            total_amount += total;
        });

        // Convert Map to array & sort alphabetically by name
        const combinedData = Array.from(productMap.values()).sort((a, b) =>
            a.itemname.localeCompare(b.itemname)
        );

        settotalamount(total_amount.toFixed(2));
        setreportData(combinedData);
    });
};



    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary" style={{ float: "right" }} >|| Product Wise Report  ||</button><br /><br />
                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" >
                                <div className='row '>
                                    <div className="col-sm-3">
                                        <label> From Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={fromdate} onChange={(e) => setfromdate(e.target.value)} />
                                    </div>
                                    <div className="col-sm-3">
                                        <label> To Date </label>
                                        <input type="date" className="form-control" style={{ height: 35, fontSize: 14 }} value={todate} onChange={(e) => settodate(e.target.value)} />
                                    </div>
                                    <div className='col-sm-3'>
                                        <br />
                                        <button onClick={() => getReport()} className='btn btn-info'>Get Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card card-primary card-outline">
                            <div className="card-body table-responsive p-3" ref={printRef}>
                                <center>
                                    <h6>Pratik Beer Shopee</h6>
                                    {/* <span>Ghatshil Road Road, Tuljapur, 413501</span><br /> */}
                                    {/* <span>Mobile No: 9921060146</span> */}
                                </center><hr />
                                <div className='row'>
                                    <div className='col-sm-4'>
                                        <span><b> From Date : </b>{moment(fromdate).format('DD/MM/YYY')}</span>
                                    </div>
                                    <div className='col-sm-4 text-center'>
                                        <h6 style={{ textTransform: "uppercase" }}>Product Wise Report</h6>
                                    </div>
                                    <div className='col-sm-4' style={{ textAlign: "right" }}>
                                        <span><b> To Date : </b>{moment(todate).format('DD/MM/YYY')}</span>
                                    </div>
                                </div>
                                <div className='row '>
                                    <table className='table table-striped'>
                                        <thead>
                                            <tr>
                                                <th>Sr No</th>
                                                {/* <th>Date</th> */}
                                                <th>Product Name</th>
                                                <th>Rate</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportData.map((item, index) => (
                                                <tr key={index}>
                                                    <td width="80">{index + 1}</td>
                                                    {/* <td>{moment(fromdate).format('DD/MM/YYYY')}</td> */}
                                                    <td>{item.itemname}</td>
                                                    <td>{item.rate.toFixed(2)}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.total.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={3}><b>Total</b></td>
                                                <td>
                                                    <b>
                                                        {reportData.reduce((sum, row) => sum + row.quantity, 0)}
                                                    </b>
                                                </td>
                                                <td><b>{totalamount}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            <center>
                                <button onClick={handlePrint} className='btn btn-info'>Print Report</button>
                            </center><br />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
